let dataProperties = {
    stopAtElement: 'sticky-scroll-until',
    tolerance: 'sticky-scroll-tolerance',
    matchMedia: 'sticky-scroll-matchmedia',
    placeHolderCls: 'sticky-scroll-placeholder-class',
    reversed: 'sticky-scroll-reversed'
};

export default class StickyScroll {
    constructor(elem, context) {
        if (!elem || !context) {
            throw new Error('Element and context required to initialize object');
        }

        this.$elem = $(elem);
        this.$context = $(context);
        this.$document = $(context.document);
        this.tolerance = this.$elem.data(dataProperties.tolerance) || 20; //This will avoid useless repaints
        this.stopAtElementSelector = this.$elem.data(dataProperties.stopAtElement) || false;

        let matchMedia = this.$elem.data(dataProperties.matchMedia) || false;
        let isReversed = this.$elem.data(dataProperties.reversed) || false;
        this.viewportIsMatched = matchMedia ? context.matchMedia(matchMedia).matches : true;

        if (this.viewportIsMatched && !this.$elem.hasClass('is-sticky-init')) {
            this.initGhost(isReversed); //This will avoid re-layouts
            this.reset();
            this.$context.scroll(() => this.render(isReversed));
        }

        $(window).on('orientationchange', () => {
            this.$elem.addClass('is-sticky-init');
            if (this.$ghost) {
                this.$elem.outerWidth(this.$ghost.innerWidth());
            }
            this.reset();
        });
    }

    initGhost(isReversed) {
        this.$elem.wrap('<div></div>');
        this.$ghost = this.$elem.parent();
        this.$elem.addClass('is-sticky-init').outerWidth(this.$ghost.innerWidth());

        if (isReversed) {
            this.$elem.addClass('is-sticky-init--reversed');
        }

        this.$ghost.addClass(this.$elem.data(dataProperties.placeHolderCls));
    }

    reset() {
        this.documentHeight = this.$document.height();
        this.stickyBannerHeight = this.$elem.outerHeight();

        if (this.$ghost) {
            this.$ghost.css('height', this.stickyBannerHeight); //Let's keep ghost in sync
            this.startBreakpoint = this.$ghost.offset().top;
        }

        let $stopElement = this.stopAtElementSelector ? $(this.stopAtElementSelector) : null;
        this.bottomBound = $stopElement && $stopElement.length > 0 ? $stopElement.offset().top : this.documentHeight;
    }

    activate() {
        let stickyBottom = this.stickyBannerHeight + this.startBreakpoint;
        return (stickyBottom + this.tolerance) < this.bottomBound;
    }

    isStickyOutOfSpawnPlace(scrollPos, reversed) {
        if (reversed) {
            return scrollPos + this.$context.height() - this.stickyBannerHeight < this.startBreakpoint;
        }

        return scrollPos > this.startBreakpoint;
    }

    render(reversed) {
        let scrollPos = this.$context.scrollTop(),
            distanceFromStop = scrollPos + this.stickyBannerHeight - this.bottomBound,
            position = distanceFromStop > 0 ? distanceFromStop * -1 : 0;

        this.reset();

        if (this.activate() && this.isStickyOutOfSpawnPlace(scrollPos, reversed)) {
            this.$elem.addClass('sticky')
                .css({
                    position: 'fixed',
                    margin: 0,
                    'z-index': 2
                });

            if (reversed) {
                this.$elem.css('bottom', 0)
                    .css('top', 'auto');
            } else {
                this.$elem.css('bottom', 'auto')
                    .css('top', position);
            }

        } else {
            this.$elem.removeClass('sticky')
                .css({
                    position: 'static',
                    margin: '',
                    top: '',
                    bottom: '',
                    'z-index': ''
                });
        }
    }
}
